import React, { useState } from 'react';
import Modal from '../Modal';

const TAX_FORM_IMAGES = [
	{ label: 'Page 1', url: 'https://arizona-leader-documents.s3.us-east-1.amazonaws.com/Form-1040-Pg1.jpg' },
	{ label: 'Page 2', url: 'https://arizona-leader-documents.s3.us-east-1.amazonaws.com/Form-1040-Pg2.jpg' },
];

const TaxFormSamples = () => {
	const [imageModal, setImageModal] = useState({ open: false, src: null });

	return (
		<>
			<div className="tax-form-samples">
				<span className="tax-form-samples__label">Sample IRS Form 1040 (click to enlarge):</span>
				<div className="tax-form-samples__thumbnails">
					{TAX_FORM_IMAGES.map(({ label, url }) => (
						<button
							key={url}
							type="button"
							className="tax-form-samples__thumb"
							onClick={() => setImageModal({ open: true, src: url })}
							aria-label={`View ${label} full size`}
						>
							<img src={url} alt={`Form 1040 ${label}`} loading="lazy" />
							<span>{label}</span>
						</button>
					))}
				</div>
			</div>
			<Modal
				open={imageModal.open}
				onClose={() => setImageModal({ open: false, src: null })}
				showHeader
				autoHeight
				wide
			>
				{imageModal.src && <img src={imageModal.src} alt="Form 1040 full size" className="tax-form-samples__full" />}
			</Modal>
		</>
	);
};

export default TaxFormSamples;
